import { useAdminDB } from '@/composables/useAdminDB'
import { applyDBProfiles, syncUserRole } from '@/composables/useAdmin'
import { loadProtectedLabels } from '@/composables/useProtectedLabels'
import { initNotificationSW } from '@/services/notifications'
import type { AuthUser } from '@/types/auth'

// Fase 4.3 do plano de otimização de login (docs/planos/PLANO-OTIMIZACAO-LOGIN.md):
// tudo que precisa rodar depois que uma sessão está estabelecida (login ao
// vivo OU sessão restaurada a frio, main.ts::bootstrap()). Hoje só existe em
// main.ts porque o reload pós-login (LoginView.vue) sempre reexecuta esse
// arquivo do zero — extraído pra um caminho único ANTES de mexer no reload em
// si (Fase 4.4), pra quando ele sumir não faltar nenhum desses passos pro
// login ao vivo.
//
// Ainda NÃO chamado por LoginView.vue::handleLogin() de propósito: enquanto o
// reload continuar existindo, main.ts::bootstrap() já roda isso de novo logo
// em seguida — chamar daqui também só duplicaria loadProfiles/labels
// protegidas/registro do SW, desfazendo o ganho da Fase 1. Fica pronto pra a
// Fase 4.4 (que remove o reload) trocar por uma chamada direta a esta função.
//
// Não inclui o refresh de message_signature em segundo plano que
// main.ts::bootstrap() ainda faz à parte — esse é só relevante pra sessão
// restaurada a frio (pode estar desatualizada no localStorage); login ao
// vivo já busca isso fresco (ver Fase 2 em LoginView.vue).
export async function initAuthenticatedSession(user: AuthUser): Promise<void> {
  try {
    const db = useAdminDB()
    const dbProfiles = await db.loadProfiles()
    applyDBProfiles(dbProfiles)
  } catch { /* usa cache do localStorage em caso de erro */ }
  loadProtectedLabels() // segundo plano — não bloqueia
  syncUserRole(user.id, user.role)
  initNotificationSW() // segundo plano (Fase 4.1) — não bloqueia
}
